module.exports = __webpack_public_path__ + "img/ИФ-1(А)-014.0fee69c9.png";